import combineClasses from "helpers/combine-classes";
import React, { Fragment, FunctionComponent } from "react";
import DynamicHeadingContent from "./DynamicHeading.interface";
import styles from "./DynamicHeading.module.scss";

const DynamicHeading: FunctionComponent<DynamicHeadingContent> = (props) => {
    let HeadingWeight = "h2" as keyof JSX.IntrinsicElements;
    const headlineSizeClass = props.headlineSize ? styles[props.headlineSize] : undefined;

    if (props.headlineWeight) {
        HeadingWeight = props.headlineWeight.toLowerCase() as keyof JSX.IntrinsicElements;
    }

    return (
        <Fragment>
            <HeadingWeight className={combineClasses([props.className, headlineSizeClass])} dangerouslySetInnerHTML={props.innerHtml}>
                {props.innerHtml ? props.children : null}
            </HeadingWeight>
        </Fragment>
    );
};

export default DynamicHeading;